export var RequestStatus;
(function(RequestStatus) {
    RequestStatus["Idle"] = "idle";
    RequestStatus["Fetching"] = "fetching";
    RequestStatus["Error"] = "error";
})(RequestStatus || (RequestStatus = {}));
